import {
  IGetUserListBody,
  IGetUserListResponse,
} from "../UsersManagementStepOne/module/constants";

import { IFetchSODConflictsBody } from "../../../../common/SODUtils/SODconstants";
import { IOfficeItemProps } from "../../../../components/OfficesList/module/constants";
import {
  IBREntitlementsItem,
  IBRItem,
  IBRRequestAndItem,
  IBRRequestItem,
  IEntitlementItem,
  IEntitlementsAndBRItem,
  IEntitlementsBRItem,
  IRequestBR,
  IUserItem,
} from "../../../../models/Entitlements";
import { IAccountOpModel, UserManagementConfigButton } from "./constants";
import { SortingRule } from "react-table";

export const actionTypes = {
  MODIFY_SELECTED_USER_MANAGEMENT: "MODIFY_SELECTED_USER_MANAGEMENT",
  ADMIN_USERS_REQUEST: "ADMIN_USERS_REQUEST",
  ADMIN_USERS_REQUEST_SUCCESS: "ADMIN_USERS_REQUEST_SUCCESS",
  ADMIN_USERS_REQUEST_FAILURE: "ADMIN_USERS_REQUEST_FAILURE",
  ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST:
    "ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST",
  ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_SUCCESS:
    "ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_SUCCESS",
  ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_FAILURE:
    "ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_FAILURE",
  ADMIN_USERS_ENTITLEMENT_REQUEST: "ADMIN_USERS_ENTITLEMENT_REQUEST",
  ADMIN_USERS_ENTITLEMENT_REQUEST_SUCCESS:
    "ADMIN_USERS_ENTITLEMENT_REQUEST_SUCCESS",
  ADMIN_USERS_ENTITLEMENT_REQUEST_FAILURE:
    "ADMIN_USERS_ENTITLEMENT_REQUEST_FAILURE",
  ADMIN_SET_ENTITLEMENTS_BR_SELECTED: "ADMIN_SET_ENTITLEMENTS_BR_SELECTED",

  SELECT_OFFICE: "ADMIN_SELECT_OFFICE",
  MODIFY_SELF_SELECTED: "ADMIN_MODIFY_SELF_SELECTED",
  MODIFY_DELEGATOR: "ADMIN_MODIFY_DELEGATOR",
  MODIFY_SHOW_ADVANCED_FILTER: "ADMIN_MODIFY_SHOW_ADVANCED_FILTER",
  MODIFY_SELECTED_USERS: "ADMIN_MODIFY_SELECTED_USERS",
  MODIFY_SELECTED_OU: "ADMIN_MODIFY_SELECTED_OU",
  MODIFY_PREV_ABILITATIONS: "ADMIN_MODIFY_PREV_ABILITATIONS",
  MODIFY_ADDED_ABILITATIONS: "ADMIN_MODIFY_ADDED_ABILITATIONS",
  MODIFY_ADDED_BR: "ADMIN_MODIFY_ADDED_BR",
  MODIFY_DELETED_ABILITATIONS: "ADMIN_MODIFY_DELETED_ABILITATIONS",
  MODIFY_REMOVED_BR: "ADMIN_MODIFY_REMOVED_BR",
  MODIFY_MODIFIED_ABILITATIONS: "ADMIN_MODIFY_MODIFIED_ABILITATIONS",
  MODIFY_TOTAL_ABILITATIONS: "ADMIN_MODIFY_TOTAL_ABILITATIONS",
  MODIFY_TOTAL_ABILITATIONS_BR: "ADMIN_MODIFY_TOTAL_ABILITATIONS_BR",
  MODIFY_COMMENT: "ADMIN_MODIFY_COMMENT",
  OFFICE_REQUEST: "ADMIN_OFFICE_REQUEST",
  OFFICE_REQUEST_SUCCESS: "ADMIN_OFFICE_REQUEST_SUCCESS",
  OFFICE_REQUEST_FAILURE: "ADMIN_OFFICE_REQUEST_FAILURE",
  USER_REQUEST: "ADMIN_USER_REQUEST",
  USER_REQUEST_SUCCESS: "ADMIN_USER_REQUEST_SUCCESS",
  USER_REQUEST_FAILURE: "ADMIN_USER_REQUEST_FAILURE",
  OU_ENTITLEMENT_REQUEST: "ADMIN_OU_ENTITLEMENT_REQUEST",
  OU_ENTITLEMENT_REQUEST_SUCCESS: "ADMIN_OU_ENTITLEMENT_REQUEST_SUCCESS",
  OU_ENTITLEMENT_REQUEST_FAILURE: "ADMIN_OU_ENTITLEMENT_REQUEST_FAILURE",
  ENTITLEMENT_REQUEST: "ADMIN_ENTITLEMENT_REQUEST",
  ENTITLEMENT_REQUEST_SUCCESS: "ADMIN_ENTITLEMENT_REQUEST_SUCCESS",
  ENTITLEMENT_REQUEST_FAILURE: "ADMIN_ENTITLEMENT_REQUEST_FAILURE",
  CREATE_REQUEST: "ADMIN_CREATE_REQUEST",
  CREATE_REQUEST_SUCCESS: "ADMIN_CREATE_REQUEST_SUCCESS",
  CREATE_REQUEST_FAILURE: "ADMIN_CREATE_REQUEST_FAILURE",
  RESET_ABILITATIONS: "ADMIN_RESET_ABILITATIONS",
  RESET_STATE: "ADMIN_RESET_STATE",
  BAO_ENTITLEMENT_REQUEST: "ADMIN_BAO_ENTITLEMENT_REQUEST",
  BAO_ENTITLEMENT_REQUEST_SUCCESS: "ADMIN_BAO_ENTITLEMENT_REQUEST_SUCCESS",
  BAO_ENTITLEMENT_REQUEST_FAILURE: "ADMIN_BAO_ENTITLEMENT_REQUEST_FAILURE",
  ENTITLEMENTS_BUSINESS_ROLES_SELECTED:
    "ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED",
  ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET:
    "ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET",
  SET_EXISTING_SAME_DB: "ADMIN_SET_EXISTING_SAME_DB",

  ADMIN_SELECT_OFFICE: "ADMIN_SELECT_OFFICE",
  ADMIN_MODIFY_SELF_SELECTED_USERS_MANAGEMENT:
    "ADMIN_MODIFY_SELF_SELECTED_USERS_MANAGEMENT",
  ADMIN_MODIFY_DELEGATOR_USERS_MANAGEMENT:
    "ADMIN_MODIFY_DELEGATOR_USERS_MANAGEMENT",
  ADMIN_MODIFY_SHOW_ADVANCED_FILTER_USERS_MANAGEMENT:
    "ADMIN_MODIFY_SHOW_ADVANCED_FILTER_USERS_MANAGEMENT",
  ADMIN_MODIFY_SELECTED_USERS_USERS_MANAGEMENT:
    "ADMIN_MODIFY_SELECTED_USERS_USERS_MANAGEMENT",
  ADMIN_MODIFY_SELECTED_OU_USERS_MANAGEMENT:
    "ADMIN_MODIFY_SELECTED_OU_USERS_MANAGEMENT",
  ADMIN_MODIFY_PREV_ABILITATIONS_USERS_MANAGEMENT:
    "ADMIN_MODIFY_PREV_ABILITATIONS_USERS_MANAGEMENT",
  ADMIN_MODIFY_ADDED_ABILITATIONS_USERS_MANAGEMENT:
    "ADMIN_MODIFY_ADDED_ABILITATIONS_USERS_MANAGEMENT",
  ADMIN_MODIFY_ADDED_BR_USERS_MANAGEMENT:
    "ADMIN_MODIFY_ADDED_BR_USERS_MANAGEMENT",
  ADMIN_MODIFY_DELETED_ABILITATIONS_USERS_MANAGEMENT:
    "ADMIN_MODIFY_DELETED_ABILITATIONS_USERS_MANAGEMENT",
  ADMIN_MODIFY_REMOVED_BR_USERS_MANAGEMENT:
    "ADMIN_MODIFY_REMOVED_BR_USERS_MANAGEMENT",
  ADMIN_MODIFY_MODIFIED_ABILITATIONS_USERS_MANAGEMENT:
    "ADMIN_MODIFY_MODIFIED_ABILITATIONS_USERS_MANAGEMENT",
  ADMIN_MODIFY_TOTAL_ABILITATIONS_USERS_MANAGEMENT:
    "ADMIN_MODIFY_TOTAL_ABILITATIONS_USERS_MANAGEMENT",
  ADMIN_MODIFY_TOTAL_ABILITATIONS_BR_USERS_MANAGEMENT:
    "ADMIN_MODIFY_TOTAL_ABILITATIONS_BR_USERS_MANAGEMENT",
  ADMIN_MODIFY_COMMENT_USERS_MANAGEMENT:
    "ADMIN_MODIFY_COMMENT_USERS_MANAGEMENT",
  ADMIN_OFFICE_REQUEST: "ADMIN_OFFICE_REQUEST",
  ADMIN_OFFICE_REQUEST_SUCCESS: "ADMIN_OFFICE_REQUEST_SUCCESS",
  ADMIN_OFFICE_REQUEST_FAILURE: "ADMIN_OFFICE_REQUEST_FAILURE",
  ADMIN_USER_REQUEST: "ADMIN_USER_REQUEST",
  ADMIN_USER_REQUEST_SUCCESS: "ADMIN_USER_REQUEST_SUCCESS",
  ADMIN_USER_REQUEST_FAILURE: "ADMIN_USER_REQUEST_FAILURE",
  ADMIN_OU_ENTITLEMENT_REQUEST: "ADMIN_OU_ENTITLEMENT_REQUEST",
  ADMIN_OU_ENTITLEMENT_REQUEST_SUCCESS: "ADMIN_OU_ENTITLEMENT_REQUEST_SUCCESS",
  ADMIN_OU_ENTITLEMENT_REQUEST_FAILURE: "ADMIN_OU_ENTITLEMENT_REQUEST_FAILURE",
  ADMIN_ENTITLEMENT_REQUEST_USERS_MANAGEMENT:
    "ADMIN_ENTITLEMENT_REQUEST_USERS_MANAGEMENT",
  ADMIN_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT:
    "ADMIN_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT",
  ADMIN_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT:
    "ADMIN_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT",
  ADMIN_CREATE_REQUEST: "ADMIN_CREATE_REQUEST",
  ADMIN_CREATE_REQUEST_SUCCESS: "ADMIN_CREATE_REQUEST_SUCCESS",
  ADMIN_CREATE_REQUEST_FAILURE: "ADMIN_CREATE_REQUEST_FAILURE",
  ADMIN_RESET_ABILITATIONS: "ADMIN_RESET_ABILITATIONS",
  ADMIN_RESET_STATE: "ADMIN_RESET_STATE",
  ADMIN_BAO_ENTITLEMENT_REQUEST_USERS_MANAGEMENT:
    "ADMIN_BAO_ENTITLEMENT_REQUEST_USERS_MANAGEMENT",
  ADMIN_BAO_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT:
    "ADMIN_BAO_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT",
  ADMIN_BAO_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT:
    "ADMIN_BAO_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT",
  ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED:
    "ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED",
  ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET:
    "ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET",
  ADMIN_SET_EXISTING_SAME_DB: "ADMIN_SET_EXISTING_SAME_DB",
  ADMIN_UPDATE_MOBILE_NUMBER: "ADMIN_UPDATE_MOBILE_NUMBER",
  ADMIN_UPDATE_MOBILE_NUMBER_SUCCESS: "ADMIN_UPDATE_MOBILE_NUMBER_SUCCESS",
  ADMIN_UPDATE_MOBILE_NUMBER_FAILURE: "ADMIN_UPDATE_MOBILE_NUMBER_FAILURE",

  USER_RESET_STATE: "ADMIN_USER_RESET_STATE",
  ENTITLEMENTS_BR_SELECTED_RESET: "ADMIN_ENTITLEMENTS_BR_SELECTED_RESET",

  ADMIN_RESET_PASSWORD: "ADMIN_RESET_PASSWORD",
  ADMIN_RESET_PASSWORD_SUCCESS: "ADMIN_RESET_PASSWORD_SUCCESS",
  ADMIN_RESET_PASSWORD_FAILURE: "ADMIN_RESET_PASSWORD_FAILURE",
  ADMIN_BLOCK_ACCOUNT: "ADMIN_BLOCK_ACCOUNT",
  ADMIN_BLOCK_ACCOUNT_SUCCESS: "ADMIN_BLOCK_ACCOUNT_SUCCESS",
  ADMIN_BLOCK_ACCOUNT_FAILURE: "ADMIN_BLOCK_ACCOUNT_FAILURE",
  ADMIN_UNLOCK_PASSWORD: "ADMIN_UNLOCK_PASSWORD",
  ADMIN_UNLOCK_PASSWORD_SUCCESS: "ADMIN_UNLOCK_PASSWORD_PASSWORD_SUCCESS",
  ADMIN_UNLOCK_PASSWORD_FAILURE: "ADMIN_UNLOCK_PASSWORD_PASSWORD_FAILURE",
  ADMIN_GET_PASSWORD: "ADMIN_GET_PASSWORDS",
  ADMIN_GET_PASSWORD_SUCCESS: "ADMIN_GET_PASSWORD_SUCCESS",
  ADMIN_GET_PASSWORD_FAILURE: "ADMIN_GET_PASSWORD_FAILURE",
  ADMIN_UPDATE_PASSWORD: "ADMIN_UPDATE_PASSWORD",
  ADMIN_POST_UPDATE: "ADMIN_POST_UPDATE",
  ADMIN_POST_UPDATE_SUCCESS: "ADMIN_POST_UPDATE_SUCCESS",
  ADMIN_POST_UPDATE_FAILURE: "ADMIN_POST_UPDATE_FAILURE",

  ADMIN_GET_USER_LIST: "ADMIN_GET_USER_LIST",
  ADMIN_GET_USER_LIST_SUCCESS: "ADMIN_GET_USER_LIST_SUCCESS",
  ADMIN_GET_USER_LIST_FAILURE: "ADMIN_GET_USER_LIST_FAILURE",

  ADMIN_SET_SELECTED_USERS: "ADMIN_SET__SELECTED_USERS",

  ADMIN_CHANGE_PASSWORD: "ADMIN_CHANGE_PASSWORD",
  ADMIN_CHANGE_PASSWORD_SUCCESS: "ADMIN_CHANGE_PASSWORD_SUCCESS",
  ADMIN_CHANGE_PASSWORD_FAILURE: "ADMIN_CHANGE_PASSWORD_FAILURE",

  ADMIN_USR_START_END_DATE: "ADMIN_USR_START_END_DATE",

  USERS_MANAGEMENT_SOD_CONFLICTS: "USERS_MANAGEMENT_SOD_CONFLICTS",
  USERS_MANAGEMENT_SOD_CONFLICTS_SUCCESS:
    "USERS_MANAGEMENT_SOD_CONFLICTS_SUCCESS",
  USERS_MANAGEMENT_SOD_CONFLICTS_FAILURE:
    "USERS_MANAGEMENT_SOD_CONFLICTS_FAILURE",
  USERS_MANAGEMENT_RESET_SOD_CONFLICTS: "USERS_MANAGEMENT_RESET_SOD_CONFLICTS",

  USERS_MANAGEMENT_SET_IS_COMMENT_COMPULSORY_ACTION:
    "USERS_MANAGEMENT_SET_IS_COMMENT_COMPULSORY_ACTION,",

  GET_POLICY_ACCOUNT_USERS_MGMT: "GET_POLICY_ACCOUNT_USERS_MGMT",
  GET_POLICY_ACCOUNT_USERS_MGMT_SUCCESS:
    "GET_POLICY_ACCOUNT_USERS_MGMT_SUCCESS",
  GET_POLICY_ACCOUNT_USERS_MGMT_FAILURE:
    "GET_POLICY_ACCOUNT_USERS_MGMT_FAILURE",

  GET_ADMIN_USER_MANAGERS: "GET_ADMIN_USER_MANAGERS",
  GET_ADMIN_USER_MANAGERS_SUCCESS: "GET_ADMIN_USER_MANAGERS_SUCCESS",
  GET_ADMIN_USER_MANAGERS_FAILURE: "GET_ADMIN_USER_MANAGERS_FAILURE",

  GET_ADMIN_USER_OUS: "GET_ADMIN_USER_OUS",
  GET_ADMIN_USER_OUS_SUCCESS: "GET_ADMIN_USER_OUS_SUCCESS",
  GET_ADMIN_USER_OUS_FAILURE: "GET_ADMIN_USER_OUS_FAILURE",

  ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST:
    "ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST",
  ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS:
    "ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS",
  ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE:
    "ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE",
  ADMIN_OFFICE_PAGINATED_BR_REQUEST: "ADMIN_OFFICE_PAGINATED_BR_REQUEST",
  ADMIN_OFFICE_PAGINATED_BR_REQUEST_SUCCESS:
    "ADMIN_OFFICE_PAGINATED_BR_REQUEST_SUCCESS",
  ADMIN_OFFICE_PAGINATED_BR_REQUEST_FAILURE:
    "ADMIN_OFFICE_PAGINATED_BR_REQUEST_FAILURE",

  USERS_MGMT_GET_ROLES_ACTION: "USERS_MGMT_GET_ROLES_ACTION",
  USERS_MGMT_GET_ROLES_ACTION_SUCCESS: "USERS_MGMT_GET_ROLES_ACTION_SUCCESS",
  USERS_MGMT_GET_ROLES_ACTION_FAILURE: "USERS_MGMT_GET_ROLES_ACTION_FAILURE",

  USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION:
    "USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION",
  USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_SUCCESS:
    "USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_SUCCESS",
  USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_FAILURE:
    "USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_FAILURE",

  USERS_MGMT_GET_CONFIG_ACTION: "USERS_MGMT_GET_CONFIG_ACTION",
  USERS_MGMT_GET_CONFIG_ACTION_SUCCESS: "USERS_MGMT_GET_CONFIG_ACTION_SUCCESS",
  USERS_MGMT_GET_CONFIG_ACTION_FAILURE: "USERS_MGMT_GET_CONFIG_ACTION_FAILURE",

  USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION:
    "USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION",
  USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_SUCCESS:
    "USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_SUCCESS",
  USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_FAILURE:
    "USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_FAILURE",
};

export const adminOfficePaginatedEntitlementRequest = (payload: {
  body: {
    userCodes: string[];
    ou?: string;
    entitlementName?: string;
    entitlementDescription?: string;
    applicationName?: string;
    applicationDescription?: string;
    pageNumber: number;
    pageSize: number;
  };
  sortBy: SortingRule<{}>[];
}) => ({
  type: actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST,
  payload,
});
export const adminOfficePaginatedEntitlementRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});
export const adminOfficePaginatedEntitlementRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const adminOfficePaginatedBrRequest = (payload: {
  body: {
    userCodes: string[];
    ou?: string;
    application?: string;
    applicationDescription?: string;
    pageNumber: number;
    pageSize: number;
  };
  sortBy: SortingRule<{}>[];
}) => ({
  type: actionTypes.ADMIN_OFFICE_PAGINATED_BR_REQUEST,
  payload,
});
export const adminOfficePaginatedBrRequestSuccess = (payload: any[]) => ({
  type: actionTypes.ADMIN_OFFICE_PAGINATED_BR_REQUEST_SUCCESS,
  payload,
});
export const adminOfficePaginatedBrRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_OFFICE_PAGINATED_BR_REQUEST_FAILURE,
  err,
});

export const userManagersRequest = (payload: any) => ({
  type: actionTypes.GET_ADMIN_USER_MANAGERS,
  payload,
});
export const userManagersRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_ADMIN_USER_MANAGERS_SUCCESS,
  payload,
});
export const userManagersRequestFailure = (err: any) => ({
  type: actionTypes.GET_ADMIN_USER_MANAGERS_FAILURE,
  err,
});
export const userOusRequest = (payload: any) => ({
  type: actionTypes.GET_ADMIN_USER_OUS,
  payload,
});
export const userOusRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_ADMIN_USER_OUS_SUCCESS,
  payload,
});
export const userOusRequestFailure = (err: any) => ({
  type: actionTypes.GET_ADMIN_USER_OUS_FAILURE,
  err,
});

export const sendUpdateAction = (data: IAccountOpModel) => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD,
  payload: data,
});

export const resetPasswordAction = (payload: {
  accountId: string;
  identitySystemId: string;
  userCode: string;
}) => ({
  type: actionTypes.ADMIN_RESET_PASSWORD,
  payload,
});

export const modifySelectedUser = (user: {}) => ({
  type: actionTypes.MODIFY_SELECTED_USER_MANAGEMENT,
  user,
});

export const passwordPolicyUsersMgmt = (payload: any) => ({
  type: actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT,
  payload,
});

export const passwordPolicyUsersMgmtSuccess = (payload: any) => ({
  type: actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT_SUCCESS,
  payload,
});

export const passwordPolicyUsersMgmtFailure = (err: any) => ({
  type: actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT_FAILURE,
  err,
});

export const usersRequest = () => ({
  type: actionTypes.ADMIN_USERS_REQUEST,
});

export const usersRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_USERS_REQUEST_SUCCESS,
  payload,
});

export const usersRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_USERS_REQUEST_FAILURE,
  err,
});

export const usersAccountRequest = (id: string) => ({
  type: actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST,
  id,
});

export const usersAccountRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_SUCCESS,
  payload,
});

export const usersAccountRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST_FAILURE,
  err,
});

export const usersEntitlementRequest = (userId: any[]) => ({
  type: actionTypes.ADMIN_USERS_ENTITLEMENT_REQUEST,
  userId,
});

export const usersEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_USERS_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const usersEntitlementRequestFailure = (err: any) => ({
  type: actionTypes.ADMIN_USERS_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const setEntitlementsBRSelected = (payload: any) => ({
  type: actionTypes.ADMIN_SET_ENTITLEMENTS_BR_SELECTED,
  payload,
});

export const entitlementsListBusinessRolesSelectedReset = () => ({
  type: actionTypes.ENTITLEMENTS_BR_SELECTED_RESET,
});

export const userResetState = () => ({
  type: actionTypes.USER_RESET_STATE,
});

export const selectOffice = (id: string) => ({
  type: actionTypes.ADMIN_SELECT_OFFICE,
  id,
});

export const businessRolesSelected = (
  payload: IEntitlementsBRItem[] | IBREntitlementsItem[]
) => ({
  type: actionTypes.ADMIN_ENTITLEMENTS_BUSINESS_ROLES_SELECTED,
  payload,
});

export const modifyIsSelfSelected = (isSelfSelected: boolean) => ({
  type: actionTypes.ADMIN_MODIFY_SELF_SELECTED_USERS_MANAGEMENT,
  isSelfSelected,
});

export const modifyDelegator = (code: string) => ({
  type: actionTypes.ADMIN_MODIFY_DELEGATOR_USERS_MANAGEMENT,
  code,
});

export const modifyShowAdvancedFilter = (showAdvancedFilter: boolean) => ({
  type: actionTypes.ADMIN_MODIFY_SHOW_ADVANCED_FILTER_USERS_MANAGEMENT,
  showAdvancedFilter,
});

export const modifySelectedUsers = (selectedUsers: IUserItem[]) => ({
  type: actionTypes.ADMIN_MODIFY_SELECTED_USERS_USERS_MANAGEMENT,
  selectedUsers,
});

export const modifySelectedOu = (selectedOu: string | number) => ({
  type: actionTypes.ADMIN_MODIFY_SELECTED_OU_USERS_MANAGEMENT,
  selectedOu,
});

export const modifyPrevAbilitations = (
  prevAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.ADMIN_MODIFY_PREV_ABILITATIONS_USERS_MANAGEMENT,
  prevAbilitations,
});

export const modifyAddedAbilitations = (
  addedAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.ADMIN_MODIFY_ADDED_ABILITATIONS_USERS_MANAGEMENT,
  addedAbilitations,
});

export const modifyAddedBR = (addedBR: IBRItem[]) => ({
  type: actionTypes.ADMIN_MODIFY_ADDED_BR_USERS_MANAGEMENT,
  addedBR,
});

export const modifyDeletedAbilitations = (
  deletedAbilitations: IEntitlementsAndBRItem[]
) => ({
  type: actionTypes.ADMIN_MODIFY_DELETED_ABILITATIONS_USERS_MANAGEMENT,
  deletedAbilitations,
});

export const modifyRemovedBR = (removedBR: IBRRequestAndItem[]) => ({
  type: actionTypes.ADMIN_MODIFY_REMOVED_BR_USERS_MANAGEMENT,
  removedBR,
});

export const modifyModifiedAbilitations = (
  modifiedAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.ADMIN_MODIFY_MODIFIED_ABILITATIONS_USERS_MANAGEMENT,
  modifiedAbilitations,
});

export const modifyTotalAbilitations = (
  totalAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.ADMIN_MODIFY_TOTAL_ABILITATIONS_USERS_MANAGEMENT,
  totalAbilitations,
});

export const modifyTotalAbilitationsBR = (
  totalAbilitations: IBRRequestItem[]
) => ({
  type: actionTypes.ADMIN_MODIFY_TOTAL_ABILITATIONS_BR_USERS_MANAGEMENT,
  totalAbilitations,
});

export const modifyComment = (comment: string) => ({
  type: actionTypes.ADMIN_MODIFY_COMMENT_USERS_MANAGEMENT,
  comment,
});

export const officeRequest = () => {
  return {
    type: actionTypes.ADMIN_OFFICE_REQUEST,
  };
};

export const officeRequestSuccess = (payload: IOfficeItemProps[]) => ({
  type: actionTypes.ADMIN_OFFICE_REQUEST_SUCCESS,
  payload,
});

export const officeRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_OFFICE_REQUEST_FAILURE,
  err,
});
export const userRequest = (id: string | number) => ({
  type: actionTypes.ADMIN_USER_REQUEST,
  id,
});

export const userRequestSuccess = (payload: IUserItem[]) => ({
  type: actionTypes.ADMIN_USER_REQUEST_SUCCESS,
  payload,
});

export const userRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_USER_REQUEST_FAILURE,
  err,
});

export const officeEntitlementRequest = (id: string | number) => ({
  type: actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST,
  id,
});

export const officeEntitlementRequestSuccess = (
  payload: IEntitlementItem[]
) => ({
  type: actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const officeEntitlementRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const entitlementRequest = (selectedUsers: IUserItem[]) => ({
  type: actionTypes.ADMIN_ENTITLEMENT_REQUEST_USERS_MANAGEMENT,
  selectedUsers,
});

export const entitlementRequestSuccess = (payload: IEntitlementItem[]) => ({
  type: actionTypes.ADMIN_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT,
  payload,
});

export const entitlementRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT,
  err,
});

export const createRequest = (abilitationObj: FormData) => ({
  type: actionTypes.ADMIN_CREATE_REQUEST,
  abilitationObj,
});

export const createRequestSuccess = () => ({
  type: actionTypes.ADMIN_CREATE_REQUEST_SUCCESS,
});

export const createRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_CREATE_REQUEST_FAILURE,
  err,
});

export const resetAbilitations = () => ({
  type: actionTypes.ADMIN_RESET_ABILITATIONS,
});

export const resetState = () => ({
  type: actionTypes.ADMIN_RESET_STATE,
});

export const baoEntitlementRequest = (id: string | number) => ({
  type: actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_USERS_MANAGEMENT,
  id,
});

export const baoEntitlementRequestSuccess = (payload: IRequestBR[]) => ({
  type: actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_SUCCESS_USERS_MANAGEMENT,
  payload,
});

export const setExistingSameDb = (payload: any[]) => ({
  type: actionTypes.ADMIN_SET_EXISTING_SAME_DB,
  payload,
});

export const baoEntitlementRequestFailure = (error: Error) => ({
  type: actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_FAILURE_USERS_MANAGEMENT,
  error,
});

export const resetPassword = () => ({
  type: actionTypes.ADMIN_RESET_PASSWORD,
});

export const resetPasswordSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_RESET_PASSWORD_SUCCESS,
  payload,
});

export const resetPasswordFailure = (error: Error) => ({
  type: actionTypes.ADMIN_RESET_PASSWORD_FAILURE,
  error,
});

export const blockAccountAction = (payload: IAccountOpModel) => {
  return {
    type: actionTypes.ADMIN_BLOCK_ACCOUNT,
    payload,
  };
};

export const blockAccountActionSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BLOCK_ACCOUNT_SUCCESS,
  payload,
});

export const blockAccountActionFailure = (error: Error) => ({
  type: actionTypes.ADMIN_BLOCK_ACCOUNT_FAILURE,
  error,
});

export const changePassword = () => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD,
});

export const changePasswordSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD_SUCCESS,
  payload,
});

export const changePasswordFailure = (error: Error) => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD_FAILURE,
  error,
});

export const getPropagationsAction = () => ({
  type: actionTypes.ADMIN_GET_PASSWORD,
});

export const getPropagationsSuccess = (response: IAccountOpModel[]) => ({
  type: actionTypes.ADMIN_GET_PASSWORD_SUCCESS,
  payload: response,
});

export const getPropagationsFailure = (err: Error) => ({
  type: actionTypes.ADMIN_GET_PASSWORD_FAILURE,
  err,
});

export const getUserListAction = (payload: IGetUserListBody) => ({
  type: actionTypes.ADMIN_GET_USER_LIST,
  payload,
});
export const getUserListActionSuccess = (payload: IGetUserListResponse) => ({
  type: actionTypes.ADMIN_GET_USER_LIST_SUCCESS,
  payload,
});
export const getUserListActionFailure = (error: Error) => ({
  type: actionTypes.ADMIN_GET_USER_LIST_FAILURE,
  error,
});

export const setSelectedUsersAction = (payload: any) => ({
  type: actionTypes.ADMIN_SET_SELECTED_USERS,
  payload,
});

export const changePasswordAction = (payload: any) => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD,
  payload,
});
export const changePasswordActionSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD_SUCCESS,
  payload,
});
export const changePasswordActionFailure = (error: Error) => ({
  type: actionTypes.ADMIN_CHANGE_PASSWORD_FAILURE,
  error,
});

export const unlockPasswordAction = (payload: IAccountOpModel) => ({
  type: actionTypes.ADMIN_UNLOCK_PASSWORD,
  payload,
});
export const unlockPasswordActionSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_UNLOCK_PASSWORD_SUCCESS,
  payload,
});
export const unlockPasswordActionFailure = (error: Error) => ({
  type: actionTypes.ADMIN_UNLOCK_PASSWORD_FAILURE,
  error,
});

export const setStartEndDate = (
  startDate: number,
  endDate: number,
  id: string | number
) => ({
  type: actionTypes.ADMIN_USR_START_END_DATE,
  payload: {
    startDate,
    endDate,
    id,
  },
});

export const sodConflictsAction = (payload: IFetchSODConflictsBody) => ({
  type: actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS,
  payload,
});

export const sodConflictsActionSuccess = (payload: any[]) => ({
  type: actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS_SUCCESS,
  payload,
});

export const sodConflictsActionFailure = (err: Error) => ({
  type: actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS_FAILURE,
  err,
});

export const updateMobileAction = (payload: any) => ({
  type: actionTypes.ADMIN_UPDATE_MOBILE_NUMBER,
  payload,
});

export const updateMobileActionSuccess = () => ({
  type: actionTypes.ADMIN_UPDATE_MOBILE_NUMBER_SUCCESS,
});

export const updateMobileActionFailure = (err: Error) => ({
  type: actionTypes.ADMIN_UPDATE_MOBILE_NUMBER_FAILURE,
  err,
});

export const resetSodConflictsAction = () => ({
  type: actionTypes.USERS_MANAGEMENT_RESET_SOD_CONFLICTS,
});

export const setIsCommentCompulsoryAction = (payload: boolean) => ({
  type: actionTypes.USERS_MANAGEMENT_SET_IS_COMMENT_COMPULSORY_ACTION,
  payload,
});

export const userManagementGetRolesAction = () => ({
  type: actionTypes.USERS_MGMT_GET_ROLES_ACTION,
});

export const userManagementGetRolesActionSuccess = (payload: any) => ({
  type: actionTypes.USERS_MGMT_GET_ROLES_ACTION_SUCCESS,
  payload,
});

export const userManagementGetRolesActionFailure = (error: any) => ({
  type: actionTypes.USERS_MGMT_GET_ROLES_ACTION_FAILURE,
  error,
});

export const userManagementGetButtonsByRoleAction = (payload: string) => ({
  type: actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION,
  payload,
});

export const userManagementGetButtonsByRoleActionSuccess = (payload: any) => ({
  type: actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_SUCCESS,
  payload,
});

export const userManagementGetButtonsByRoleActionFailure = (error: any) => ({
  type: actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION_FAILURE,
  error,
});

export const userManagementGetConfigAction = () => ({
  type: actionTypes.USERS_MGMT_GET_CONFIG_ACTION,
});

export const userManagementGetConfigActionSuccess = (payload: any) => ({
  type: actionTypes.USERS_MGMT_GET_CONFIG_ACTION_SUCCESS,
  payload,
});

export const userManagementGetConfigActionFailure = (error: any) => ({
  type: actionTypes.USERS_MGMT_GET_CONFIG_ACTION_FAILURE,
  error,
});

export const userManagementUpdateConfigButtonsAction = (
  payload: UserManagementConfigButton
) => ({
  type: actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION,
  payload,
});

export const userManagementUpdateConfigButtonsActionSuccess = (
  payload: any
) => ({
  type: actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_SUCCESS,
  payload,
});

export const userManagementUpdateConfigButtonsActionFailure = (error: any) => ({
  type: actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION_FAILURE,
  error,
});
